import {
  Component,
  ElementRef,
  OnInit,
  ViewChild,
  ChangeDetectionStrategy
} from '@angular/core';
import {
    FormBuilder,
    FormControl,
    FormGroup,
    Validators
} from '@angular/forms';
import { ComboBoxComponent } from '@progress/kendo-angular-dropdowns';
//import { formComponentMapOptions } from '~/front-models/form-component-map';
import { PackTransaction } from '~/front-models/transactionGrid';
import { ComponentBase } from '~/infrastructure/component-base';
import { GridFieldSummary } from '~/models/modules/gridField';
import { AccountsService } from '~/services/administration.ts/accounts';
import { AccountsDropdownComponent } from '~/shared/components/accounts-dropdown/accounts-dropdown.component';
import { GridFieldsService } from '~/services/modules/stocks/gridField';
import { ThemeManagerService } from '~/services/theme-manager';
import { GridLayoutManagerService } from '~/shared/components/grid/layout/grid-layout-manager';
import { LayoutManagerService } from '~/shared/components/layout/layout-manager';
import { LayoutComponent } from '~/shared/components/layout/layout.component';
import { ReportViewerPopupComponent } from '../../../../shared/components/viewer/popup.component';
import { PageState } from '~/shared/enums/stock-files.enum';
import { UserSummary } from '~/models/administration/user';
import { SecurityService } from '~/services/security.service';
import { PackListWtihTransactionNumberListing } from '~/models/modules/packList';
import { PackListsService } from '~/services/modules/stocks/packList';
import { SalesOrderDetailForPack } from '~/front-models/salesOrderGrid';
import { IssueTransactionsService } from '~/services/modules/stocks/issue-transaction';
import { PackTransactionsService } from '~/services/modules/stocks/pack-transaction';
import { PackSettingsService } from '~/services/administration.ts/pack-settings';
import { ReportsService } from '~/services/modules/reports/reports';
import { FormatService } from '~/services/administration.ts/format';
import { GridFieldTextSummary } from '~/models/modules/GridFieldText';
import { GridFieldAuthorization } from '~/models/administration/securityLevel';
import { Router } from '@angular/router';
import { SitesEnum } from '~/shared/enums/sites.enum';
@Component({
    selector: 'app-stock-pack',
    templateUrl: './pack.html',
    styleUrls: ['./pack.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class StockPackComponent extends ComponentBase implements OnInit {
    _currentUser: UserSummary;
    _theme: string;
    _datePickerFormat: string;
    _costFormat: string;
    _form: FormGroup;
    _invalidForm: boolean;
    _selectedAccount = new FormControl();
    _sortingSelected = new FormControl('old');
    _sites: any[];
    _sitesFiltered: any[];
    _isMultiSiteSelected: boolean = false;
    _inventoryGridData: PackTransaction[] = [];
    _stockItemsGridColumns: GridFieldSummary[];
    transactionId: number;
    _packAgainstSO: boolean = false;
    _addClassActive: boolean = false;
    _packList: PackListWtihTransactionNumberListing[] = [];
    _packListFiltered: PackListWtihTransactionNumberListing[];
    _packReportId: number;


    _selectedAccountIds: any[] = [];
    _pageState: PageState;
    _language: string = 'en';
    _page: string = 'packTransaction';
    _selectedLabelText: any;
    _selectedLabelObjectCode: any;
    _editFormActive: boolean;
    _isTransaction: boolean = false;
    _onlyRequired: boolean = false;
    _hasRequired: boolean = false;

    _isRenameFormValue: boolean = false;
    _isRenameCustomFormValue: boolean = false;
    _isRenameLabel: boolean = false;
    _isMandatory: boolean = false;
    _isCustomfieldsFormValue: boolean = false;
    _isAddTabFormValue: boolean = false;


    _gridFieldText: GridFieldTextSummary[];
    _gridFieldAuth: GridFieldAuthorization[];

    @ViewChild('kendo_combo_accounts') kendoComboAccounts: AccountsDropdownComponent;
    @ViewChild('kendo_combo_sites') kendoComboSites: ComboBoxComponent;
    @ViewChild('kendo_combo_Pack_list') kendoComboPackList: ComboBoxComponent;
    @ViewChild('Kendo_Input_Transaction_note') KendoInputTransactionnote: ElementRef;

    constructor(
        private _fb: FormBuilder,
        private _themeManager: ThemeManagerService,
        private _accountsService: AccountsService,
        private _layoutComponent: LayoutComponent,
        private _layoutManager: LayoutManagerService,
        private _gridLayoutManagerService: GridLayoutManagerService,
        private _gridFields: GridFieldsService,
        private _securityService: SecurityService,
        private _packListsService: PackListsService,
        private _issueTransactionsService: IssueTransactionsService,
        private _packTransactionsService: PackTransactionsService,
        private _packSettingsService: PackSettingsService,
        private _formatService: FormatService,
        private _reportService: ReportsService,
        private router: Router
    ) {
        super();
        this._themeManager.themeChange.subscribe((data) => {
            this._theme = data;
        });

        this._layoutManager.okCloseClicked.subscribe((data) => {
            if (data) {
                if (this._currentUser?.isEnterprise && this._selectedAccount.value == null) {
                    setTimeout(() => {
                        this.kendoComboAccounts.toggle(true);
                        this.kendoComboAccounts.focus();
                    });
                } else {
                    setTimeout(() => {
                        this.kendoComboPackList.toggle(true);
                        this.kendoComboPackList.focus();
                    });
                }
            }
        });

        this._gridFields
            .getGridFieldsByPage('stockItems')

            .subscribe((data: any) => {
                this._gridLayoutManagerService.setGridColumnSubjects('stockItems', data);
            });

        this.registerSubscription(this._gridLayoutManagerService.subscribeToColumnsChanges('stockItems', (gridColumns) => {
            this._stockItemsGridColumns = gridColumns;
        }));

        this._getReportIdByName('Packing Report');
        this._currentUser = this._securityService.currentUser;
        this._pageState = PageState.ADD;

        this.loadLabels();
    }
    ngOnInit() {
        this._initForm();
        this._OpenAccount();

        this._packSettingsService.getPackSetting()

            .subscribe(res => {
                this._packAgainstSO = res.packVerification == "againstSaleOrder";
                this._initForm();
                this._loadPackListForPack();
            });

        this._selectedAccount.valueChanges.subscribe((x) => {
            if (x) {
                if (this._isMultiSiteSelected) {
                    this._form.get('site')?.setValue(SitesEnum.AllSites);
                }
                this._accountsService.getSitesListByAccount(x.id)
                    .subscribe((data: any) => {
                        this._sites = data.filter((x: any) => x.id != SitesEnum.AllSites);
                        this._sitesFiltered = this._sites;

                        if (!this._isMultiSiteSelected && this._sites?.length > 0) {
                            const currentSite = this._form.get('site')?.value;
                            if (!currentSite) {
                                this._form.get('site')?.setValue(this._sites[0].id);
                            }
                        }

                        if (this._isMultiSiteSelected && this.kendoComboSites) {
                            setTimeout(() => {
                                this.kendoComboSites.toggle(true);
                                this.kendoComboSites.focus();
                            });
                        }
                    });
            }
        });

        this._sortingSelected.valueChanges.subscribe((x) => {
            this._inventoryGridData.reverse();
        });

        this._form.get('site')?.valueChanges.subscribe((x) => {
            if (x) {
                setTimeout(() => {
                    this.kendoComboPackList.toggle(true);
                    this.kendoComboPackList.focus();
                });
            }
        });
        /** Format */
        this._datePickerFormat = this._formatService.dateFormat;
        this._costFormat = this._formatService.costFormatValue;
    }

    _OpenAccount() {
        if (this._currentUser?.isEnterprise) {
            setTimeout(() => {
                this.kendoComboAccounts.toggle(true);
                this.kendoComboAccounts.focus();
            });
        }
        else {
            setTimeout(() => {
                this.kendoComboPackList.toggle(true);
                this.kendoComboPackList.focus();
            });
        }
    }
    _editFormState() {
        this._pageState = PageState.EDIT_FIELDS;
    }

    _returnAddNew() {
        this._pageState = PageState.ADD;
    }
    _packListNumberChange() {
        setTimeout(() => {
            this.KendoInputTransactionnote.nativeElement.focus();
            let TransactionNotes = this.KendoInputTransactionnote;
            TransactionNotes.nativeElement.classList.add('focusedInput');
        });
    }
    _skipTransactionNotes() {
        let TransactionNotes = this.KendoInputTransactionnote;
        TransactionNotes.nativeElement.classList.remove('focusedInput');
        TransactionNotes.nativeElement.blur();
        this._addClassActive = true;
    }
    _focustransactionNotes() {
        let TransactionNotes = this.KendoInputTransactionnote;
        TransactionNotes.nativeElement.classList.add('focusedInput');
        this._addClassActive = false;
    }
    _focusOutTransactionNotes() {
        setTimeout(() => {
            let TransactionNotes = this.KendoInputTransactionnote;
            TransactionNotes.nativeElement.classList.remove('focusedInput');
        }, 200);
    }
    _siteOpenEvent() {
        let TransactionNotes = this.KendoInputTransactionnote;
        TransactionNotes.nativeElement.classList.remove('focusedInput');
        this._addClassActive = false;
    }
    _packListOpenEvent() {
        let TransactionNotes = this.KendoInputTransactionnote;
        TransactionNotes.nativeElement.classList.remove('focusedInput');
        this._addClassActive = false;
    }

    _handleSitesFilter(value: any) {
        this._sitesFiltered = this._sites.filter(
            (s) => s.name.toLowerCase().indexOf(value.toLowerCase()) !== -1
        );
    }

    _loadPackListForPack() {
        return this._packListsService.getPackListsListingForPack(this._packAgainstSO)
            .subscribe((data) => {
                this._packList = data;
                this._packListFiltered = data;
                this._packListFiltered.forEach((item: any) => {
                    item.Concat = item.packingListNumber + "  | " + item.transactionNumber;
                });
                setTimeout(() => {
                    this.kendoComboPackList.toggle(true);
                    this.kendoComboPackList.focus();
                });
            });
    }

    ClosePopup(event: boolean) {
        if (event == true) {
            this._closeCustomFields();
        }
    }

    _handlePackListsSelection(value: any) {
        this._inventoryGridData = [];
        if (value != null && value.id != null && value.transactionNumber != null) {
            setTimeout(() => {
                this.transactionId = Number(value.transactionNumber);
                this._issueTransactionsService.getIssueDetails(this.transactionId)

                    .subscribe((data: any) => {
                        data.forEach((item: SalesOrderDetailForPack) => {
                            this._inventoryGridData.push({
                                transactionNumber: item.stockIssueId,
                                historyDate: item.createdOn,
                                inventoryCode: item.inventoryNumber,
                                itemNumber: item.stock.number,
                                locationCode: item.location.code,
                                customerCode: item.customer.code,
                                quantityChange: item.issueQuantity
                            });
                        });
                    });
            });
        } else {
            this.transactionId = null;
        }
    }

    _onSave(e: any) {
        if (this._form.invalid) {
            this._invalidForm = true;
        } else {
            this._invalidForm = false;
            const formModel = this._form.value;
            let model: any = {};
            model['packed'] = true;
            model['packingNotes'] = formModel.notes;
            var transactionNumber = this._packAgainstSO ? formModel.salesOrder.transactionNumber : formModel.packList.transactionNumber;
            this._packTransactionsService
                .updatePack(transactionNumber, model)

                .subscribe((data: any) => {
                    var msg = "";
                    if (data != null && data.message != null) {
                        msg = 'Successfully packed.';
                    } else {
                        msg = 'Error';
                    }
                    this._loadPackListForPack();
                    this._layoutComponent.openPopup({
                        title: 'Alert',
                        message: msg,
                        returnAfterOkCloseClick: true,
                        withoutConfirm: true
                    });
                    this._onClear();
                });
        }
    }

    _getReportIdByName(reportname: string) {
        this._reportService.ReportIdByName(reportname)
            .subscribe(
                (reportid) => {
                    switch (reportname) {
                        case 'Packing Report':
                            this._packReportId = reportid;
                            break;
                        default:
                            break;
                    }
                }
            );
    }

    _printReceiptReport() {
        if (this.transactionId != null) {
            var reportId = this._packReportId; //get pack report id by name "Pack List Default Print"
            this._layoutComponent.openDialogForm(ReportViewerPopupComponent, PageState.VIEW, { reportId: reportId, transactionId: this.transactionId });
        } else {
            if (this._form.invalid) {
                this._invalidForm = true;
            }
        }
    }

    _openForm(formName: string) {
        //this._layoutComponent.openDialogForm(formComponentMapOptions[formName]);
    }
    getLabel(objectCode: any) {
        if (this._gridFieldText) {
            if (this._gridFieldText.find(({ gridFieldDefinition }) => gridFieldDefinition?.objectCode === objectCode))
                var result = this._gridFieldText.find(({ gridFieldDefinition }) => gridFieldDefinition?.objectCode === objectCode)
            else
                result = null

            return result ? result : null;
        }
    }

    private loadLabels() {
        this._gridFields.getGridFieldTextLabelByPage(this._page, this._language)

            .subscribe((data: GridFieldTextSummary[]) => {
                this._gridFieldText = data;
                this._initForm();
            })
    }
    _openRenameForm(objectCode: string, isMandatory: boolean = false, onlyRequired: boolean = false, hasRequired: boolean = false) {
        this._selectedLabelText = this.getLabel(objectCode)?.text;
        this._selectedLabelObjectCode = objectCode;
        //todo send system field label id
        //return;
        //open form once label id is set
        this._editFormActive = true;
        this._isRenameFormValue = true;
        this._isRenameCustomFormValue = false;
        this._isRenameLabel = true;
        this._isMandatory = isMandatory;
        this._isTransaction = true;
        this._onlyRequired = onlyRequired;
        this._hasRequired = hasRequired;
    }

    _closeCustomFields() {
        this._editFormActive = false;
        this._isCustomfieldsFormValue = false;
        this._isAddTabFormValue = false;
        this._isRenameFormValue = false;
        // this.loadCustomFields(this._model?.id?.toString());
        this.loadLabels();
        // this.getFormTabs();
        this.getAuth();
        this._isTransaction = false;
        this._onlyRequired = false;
        this._hasRequired = false;

    }
    getAuth() {
        // this._gridFields.getFileAuthorization(this._auth, this._currentUser.appRole.id)
        this._gridFields.getFieldsAuthorization(this._page, this._currentUser?.appRole.id)

            .subscribe((x: GridFieldAuthorization[]) => {
                this._gridFieldAuth = x;
            });
    }

    _onClear() {
        this.transactionId = null;
        this._initForm();
        if (this._currentUser?.isEnterprise) {
            this._selectedAccount.setValue(null);
        }
        this._inventoryGridData = [];
        if (this.kendoComboPackList) {
            this.kendoComboPackList.reset();
        }
        this._invalidForm = false;
        this._OpenAccount();
    }

    private _initForm() {
        if (this._packAgainstSO) {
            this._form = this._fb.group({
                site: [null],
                salesOrder: [null, Validators.required],
                notes: null
            });
        } else {
            this._form = this._fb.group({
                site: [null],
                packList: [null, Validators.required],
                notes: null
            });
        }
        const loggedInAccountSites = localStorage.getItem('loggedInAccountSites') ?? "";
        if (loggedInAccountSites != "") {
            const parsedSites = JSON.parse(loggedInAccountSites);
            if (parsedSites && parsedSites.length > 0) {
                var accountId = parsedSites[0].accountId;
                if (!this._currentUser?.isEnterprise) {
                    this._selectedAccount.setValue({ id: accountId });
                }
                var siteId = parsedSites[0].siteId;
                if (!siteId && !this._currentUser?.isEnterprise) {
                    this.router.navigate(['/']);
                }
                if (siteId != null && siteId != SitesEnum.AllSites && siteId != 0) {
                    this._isMultiSiteSelected = false;
                    this._form.get('site')?.setValue(siteId);
                } else {
                    this._isMultiSiteSelected = true;
                }
            } else {
                this._isMultiSiteSelected = true;
            }
        } else {
            this._isMultiSiteSelected = true;
        }
    }
}
